import React, { useState } from 'react';
import { useParams } from 'react-router';

import SectionLoader, {
  LOADER_TYPE,
} from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { EmailFileEntry } from '@/src/components/project/Inbox2/types';

import Header from './Header';
import MainEmailFileEntryViewer from './MainEmailFileEntryViewer';
import { useMappeEmailEntryFile } from './useMappedEmailEntryFile';

type FileViewerProps = {
  emailId: number;
  inboxEntryId: number;
  emailFileEntry: EmailFileEntry;
  allFiles: EmailFileEntry[];
  totalCount: number;
  isSentEmailType: boolean;
  onSetEmailFileEntry: (emailFileEntry: any) => void;
  isSourceListFetching?: boolean;
  onFetchNextPage?: () => void;
  onCloseFileViewer?: () => void;
};

const FileEntryViewer = ({
  inboxEntryId,
  emailId,
  emailFileEntry,
  allFiles,
  totalCount,
  isSentEmailType,
  onSetEmailFileEntry,
  isSourceListFetching = false,
  onFetchNextPage = null,
  onCloseFileViewer,
}: FileViewerProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { mappedFileEntry, isLoading: isDetailsLoading } = useMappeEmailEntryFile({
    projectId,
    inboxEntryId,
    emailId,
    fileId: emailFileEntry.file.id,
  });

  const [nextIndex, setNextIndex] = useState(null);

  if (!mappedFileEntry) {
    return <SectionLoader loaderType={LOADER_TYPE.screen} />;
  }

  const isLoading = isSourceListFetching || isDetailsLoading;

  const handleFetchNextPage = (index: number) => {
    if (onFetchNextPage) {
      onFetchNextPage();
    }

    setNextIndex(index);
  };

  return (
    <MainEmailFileEntryViewer
      emailId={emailId}
      inboxEntryId={inboxEntryId}
      mappedFileEntry={mappedFileEntry}
      allFiles={allFiles}
      isLoading={isLoading}
      onSetEmailFileEntry={onSetEmailFileEntry}
      nextIndex={nextIndex}
      setNextIndex={setNextIndex}
      Header={
        <Header
          onSetEmailFileEntry={onSetEmailFileEntry}
          fileEntry={mappedFileEntry}
          files={allFiles}
          isSentEmailType={isSentEmailType}
          totalCount={totalCount}
          onFetchNextPage={handleFetchNextPage}
          onCloseFileViewer={onCloseFileViewer}
        />
      }
    />
  );
};

export default FileEntryViewer;
